<template>
    <div>
        <b-modal id="csv-import" title="Import affiliates from CSV" :hide-footer="hideFooter">
            <table class="table">
                <thead>
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">Affiliate code</th>
                    <th scope="col">Bookmaker</th>
                    <th scope="col">Description:</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(aff, index) in csvData" :key="aff.affcode">
                    <th scope="row">{{index +1 }}</th>
                    <td>{{ aff.affcode }}</td>
                    <td>{{ aff.bookmaker }}</td>
                    <td>{{ aff.description }}</td>
                </tr>
                </tbody>
            </table>
            <form>
                <div class="form-group">
                    <button type="submit" class="btn btn-secondary form-control" @click.prevent="importAffiliates">Import</button>
                    <button type="submit" class="btn btn-danger form-control" @click.prevent="cancelImport">Cancel</button>
                </div>
            </form>
        </b-modal>

    </div>
</template>

<script>
import { Bus } from '@/main'
export default {
  data () {
    return {
      hideFooter: true,
      csvData: []
    }
  },
  methods: {
    importAffiliates () {
      // do the trick
      const formData = new FormData()
      formData.append('csvData', JSON.stringify(this.csvData))
      this.$http.post(`${this.$api_url}/affcodes/importCSVData`,
        formData).then(data => {
        // emit data to the modal
        Bus.$emit('csvDataImported')
        this.$bvModal.hide('csv-import')
      }).catch(err => {
        alert('Error while importing CSV data' + err)
      })
    },
    cancelImport () {
      // remove the CSV file
      this.$bvModal.hide('csv-import')
    }
  },
  computed: {

  },
  created () {
    Bus.$on('csvData', (data) => {
      this.csvData = data
    })
  },
  beforeDestroy () {
    Bus.$off('csvData')
  }
}
</script>
<style scoped>
</style>
